/* */ 
'use strict';
var Promise = require('./promise'),
    debug = require('./debug');
exports.all = function(plugins) {
  return Object.keys(plugins).filter(function(key) {
    return typeof plugins[key] === 'object';
  }).map(function(key) {
    plugins[key].name = key;
    return plugins[key];
  });
};
exports.filter = function(plugins, method, file) {
  return plugins.filter(function(plugin) {
    return !!getResult(plugin, method, file);
  });
};
exports.sort = function(plugins) {
  plugins.forEach(function(plugin) {
    plugin.order = plugin.order || Number.MAX_SAFE_INTEGER;
  });
  return plugins.sort(function(a, b) {
    return a.order - b.order;
  });
};
exports.run = function(plugins, method, file) {
  var plugin,
      lastError,
      index = 0;
  return new Promise(function(resolve, reject) {
    runNextPlugin();
    function runNextPlugin() {
      plugin = plugins[index++];
      if (!plugin) {
        return reject(lastError);
      }
      try {
        debug('  %s', plugin.name);
        var result = getResult(plugin, method, file, callback);
        if (result && typeof result.then === 'function') {
          result.then(onSuccess, onError);
        } else if (result !== undefined) {
          onSuccess(result);
        }
      } catch (e) {
        onError(e);
      }
    }
    function callback(err, result) {
      if (err) {
        onError(err);
      } else {
        onSuccess(result);
      }
    }
    function onSuccess(result) {
      debug('    success');
      resolve({
        plugin: plugin,
        result: result
      });
    }
    function onError(err) {
      debug('    %s', err.message || err);
      lastError = err;
      runNextPlugin();
    }
  });
};
function getResult(obj, prop, file, callback) {
  var value = obj[prop];
  if (typeof value === 'function') {
    return value.apply(obj, [file, callback]);
  }
  if (!callback) {
    if (value instanceof RegExp) {
      return value.test(file.url);
    } else if (typeof value === 'string') {
      return value === file.extension;
    } else if (Array.isArray(value)) {
      return value.indexOf(file.extension) !== -1;
    }
  }
  return value;
}
